import Notifications from './component'
export default Notifications
